import React from 'react';

// Import shared components
import SubBanner from '../components/SubBanner';
import Pricing from '../components/Pricing';
import Statistics from '../components/Statistics';
import Testimonials from '../components/Testimonials';
import CallToAction from '../components/CallToAction';

const PricingPage = () => {
  return (
    <>
      {/* The SubBanner is reusable, we just pass new props */}
      <SubBanner title="Pricing" breadcrumb="Pricing" />
      
      {/* 
        The "main-pricing-con" class from the original HTML is a simple marker.
        We can achieve the same result by wrapping the Pricing component or adding a prop.
        For simplicity, we will just render the component. The key styles are already inside it.
      */}
      <Pricing />
      
      {/* These sections are identical to the ones on other pages, so we reuse them */}
      <Statistics />
      <Testimonials />
      <CallToAction />
    </>
  );
};

export default PricingPage;